module.exports = __webpack_public_path__ + "static/media/vision.8dc9cf47.jpg";